import { ApplicationController } from "../../application_controller"
import Rails from '@rails/ujs'

export default class extends ApplicationController {
    initialize() {
	this.autoSave = _.debounce(this.autoSave, 5000)
    }

    connect() {}

    destroy() {}

    setup(event) {
	var toolbar = event.target.toolbarElement

	var group = document.createElement("span")
	group.className = "trix-button-group"

	// save button
	var button = document.createElement("button")
	button.type = "button"
	button.className = "trix-button trix-button--save"
	button.textContent = "Saved"
	button.dataset.action = "click->layouts--helpers--trix-public#save"
	group.appendChild(button)

	// auto save button
	var button = document.createElement("button")
	button.type = "button"
	button.className = "trix-button trix-button--icon trix-button--autosave"
	button.textContent = "Auto Save"
	button.title = "Auto Save"
	button.dataset.action = "click->layouts--helpers--trix-public#toggleAutoSave"
	group.appendChild(button)

	toolbar.querySelector(".trix-button-row").appendChild(group)
	this.element.dataset.autosave = 'true'

	// spacer
	group.before(document.querySelector(".trix-button-group-spacer"))

	// heading buttons
	this.addHeadingTags(this.element.closest('form').querySelector('trix-editor'))

	// underline button
	var button = document.createElement("button")
	button.type = "button"
	button.className = "trix-button trix-button--icon trix-button--underline"
	button.textContent = "U"
	button.dataset.trixAttribute = "underline"
	button.title = "Underline"
	button.tabIndex = "-1"
	button.setAttribute("data-trix-key", "u")
	var group = toolbar.querySelector(".trix-button-group.trix-button-group--text-tools")
	group.insertBefore(button, group.children[2])

	// highlight button
	var button = document.createElement("button")
	button.type = "button"
	button.className = "trix-button trix-button--icon trix-button--highlight"
	button.textContent = "H"
	button.dataset.trixAttribute = "highlight"
	button.title = "Highlight"
	button.tabIndex = "-1"
	button.setAttribute("data-trix-key", "h")
	var group = toolbar.querySelector(".trix-button-group.trix-button-group--text-tools")
	group.insertBefore(button, group.children[4])

	// lock button
	var button = document.createElement("button")
	button.type = "button"
	button.className = "trix-button trix-button--icon trix-button--lock"
	button.textContent = "L"
	button.dataset.trixAttribute = "lock"
	button.title = "Lock"
	button.tabIndex = "-1"
	button.setAttribute("data-trix-key", "l")
	var group = toolbar.querySelector(".trix-button-group.trix-button-group--text-tools")
	group.insertBefore(button, group.children[6])

	// paragraph button
	var button = document.createElement("button")
	button.type = "button"
	button.className = "trix-button trix-button--icon trix-button--paragraph"
	button.textContent = "P"
	button.dataset.trixAttribute = "paragraph"
	button.title = "Paragraph"
	button.tabIndex = "-1"
	button.setAttribute("data-trix-key", "p")
	var group = toolbar.querySelector(".trix-button-group.trix-button-group--block-tools")
	group.insertBefore(button, group.children[1])
    }

    toggleAutoSave(event) {
	event.preventDefault()
	this.element.dataset.autosave = this.element.dataset.autosave  == "true" ? "false" : "true"

	if(this.element.dataset.autosave == 'true') {
	    event.target.textContent = "Auto Save"
	    event.target.title = "Auto Save"
	    event.target.classList.remove('trix-button--inactive')
	} else {
	    event.target.textContent = "Manual Save"
	    event.target.title = "Manual Save"
	    event.target.classList.add('trix-button--inactive')
	}
    }

    update(event) {
	event.target.closest('form').querySelector('trix-toolbar .trix-button.trix-button--save').textContent = "Save Changes"
	this.autoSave(event)
    }

    autoSave(event) {
	if(this.element.dataset.autosave == 'true') {
	    event.target.closest('form').querySelector('trix-toolbar .trix-button.trix-button--save').click()
	}
    }

    save(event) {
	event.target.textContent = "Saving..."
	Rails.fire(event.target.closest('form'), 'submit')
    }


    addHeadingTags(element) {
	let toolbarElement = element.toolbarElement
	let buttonGroupBlockTools = toolbarElement.querySelector("[data-trix-button-group=block-tools]")
	if(buttonGroupBlockTools) {
	    buttonGroupBlockTools.removeChild(toolbarElement.querySelector("[data-trix-attribute=heading1]"))
	    buttonGroupBlockTools.insertAdjacentHTML("afterbegin", this.headingButtonTemplate)
	    toolbarElement.querySelector("[data-trix-dialogs]").insertAdjacentHTML("beforeend", this.dialogHeadingTemplate)
	}
    }

    get headingButtonTemplate() {
	return `<button type="button" class="trix-button trix-button--icon trix-button--icon-heading-1" data-trix-action="x-heading" title="Heading" tabindex="-1">Heading</button>`
    }

    get dialogHeadingTemplate() {
	return `
          <div class="trix-dialog trix-dialog--heading" data-trix-dialog="x-heading" data-trix-dialog-attribute="x-heading">
            <div class="trix-dialog__link-fields">
              <input type="text" name="x-heading" class="trix-dialog-hidden__input" data-trix-input>
              <div class="trix-button-group">
                <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading1">H1</button>
                <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading2">H2</button>
                <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading3">H3</button>
                <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading4">H4</button>
                <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading5">H5</button>
                <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading6">H6</button>
              </div>
            </div>
          </div>
	`
    }
}
